import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rectangle",
  "use": "icon-rectangle-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rectangle\">\n<rect x=\"0.5\" y=\"0.5\" width=\"13\" height=\"13\" rx=\"6.5\" fill=\"white\" stroke=\"#D6D8DE\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol